<template>
  <div class="Kanit pb-14">
    <slot name="header"></slot>
    <div class="text-center Kanit my-3" style="font-weight: 500">กรุณา Scan หรือกรอกเลข IMEI</div>
    <!-- <div class="text-center mb-2" :key="lastcode">{{ lastcode }}</div> -->
    <div class="text-center">
      <!-- <div id="barcode-scanner"></div> -->
      <!-- <div class="redline"></div> -->
      <div id="reader"></div>
      <!-- <input type="file" id="qr-input-file" @input="uploadToScan" accept="image/*"> -->
      <!-- <div>
        {{ result }}
      </div> -->
    </div>
    <div class="px-5 pt-4 mx-auto pb-5" style="max-width: 500px">
      <ValidationObserver ref="observer">
        <ValidationProvider name="Imei" :rules="{ required: true }" v-slot="{ errors }">
          <custom-input
            label="กรอกเลข Imei"
            maxlength="15"
            :outlined="true"
            :error-messages="errors"
            v-model="input.imei"
          ></custom-input>
        </ValidationProvider>
      </ValidationObserver>
      <div class="text-center mb-7">
        <v-btn @click="onAddImei" :loading="loading" color="primary">Add</v-btn>
      </div>
      <div class="mt-2" v-for="(item, k) in imeiList" :key="k">
        <v-card color="#D1D8E4" class="pa-2 primary--text">
          <v-row dense class="mx-0">
            <v-col cols="6">
              <div>
                <span style="font-weight: 500">
                  {{ item.imei }}
                </span>
              </div></v-col
            >
            <v-col cols="6">
              <div @click="deleteImei(k)" style="float: right">
                <v-icon color="primary">delete</v-icon>
              </div></v-col
            >
            <v-col cols="6">
              {{ item.description ? item.description : "-" }}
            </v-col>
            <v-col cols="6" class="text-right">
              <span style="font-size: 20px"
                >{{
                  item.points || item.points === 0 ? `+${numberFormat(item.points)}` : "-"
                }}
                เครื่อง</span
              >
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>

    {{ result }}

    <v-dialog v-model="loading" persistent width="300">
      <v-card>
        <v-card-text>
          Loading
          <v-progress-linear indeterminate color="primary" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div style="position: fixed; bottom: 0px; width: 100%">
      <v-btn
        :loading="saveloading"
        @click="submitData"
        :disabled="!imeiList.length"
        tile
        style="font-size: 22px"
        x-large
        block
        color="primary"
      >
        เสร็จสิ้น
      </v-btn>
    </div>
  </div>
</template>

<script>
import Quagga from "@ericblade/quagga2";
import axios from "axios";
import MobileDetect from "mobile-detect";
import CustomInput from "../components/CustomInput.vue";
export default {
  components: { CustomInput },
  data() {
    return {
      input: {
        imei: "",
      },
      imeiList: [],
      loading: false,
      saveloading: false,
      qrbox: "",
      fps: "",
      result: "",
      doStream: false,
    };
  },
  created() {
    this.$root.$on(
      "decodedCode",
      function (decodedText, decodedResult) {
        this.decodedText = decodedText;
      }.bind(this)
    );
  },
  async mounted() {
    try {
      await this.$loadScript("https://cdn.jsdelivr.net/npm/scandit-sdk@5.x");
      ScanditSDK.configure(this.$store.state.config[this.$store.state.env].scandit, {
        engineLocation: "https://cdn.jsdelivr.net/npm/scandit-sdk@5.x/build/",
      })
        .then(() => {
          return ScanditSDK.BarcodePicker.create(document.getElementById("reader"), {
            playSoundOnScan: true,
            // enable some common symbologies
            scanSettings: new ScanditSDK.ScanSettings({
              enabledSymbologies: ["code128", "qr", "code93", "codabar", "msi-plessey"],
            }),
          });
        })
        .then((barcodePicker) => {
          // barcodePicker is ready here, show a message every time a barcode is scanned
          barcodePicker.on("scan", (scanResult) => {
            let decodedText = scanResult.barcodes[0].data;
            // alert(scanResult.barcodes[0].data);
            this.onDetectedCode(decodedText);
          });
        });
    } catch (error) {
      // alert(error.message)
      console.error(error);
    }
    // await this.$loadScript("https://unpkg.com/html5-qrcode")
    //   .then(() => {
    //     const html5QrCode = new Html5Qrcode("reader");
    //     const qrCodeSuccessCallback = (decodedText, decodedResult) => {
    //       /* handle success */

    //       this.result = decodedResult;
    //       // this.onDetectedCode(decodedText);
    //     };
    //     const config = {
    //       fps: 24,
    //       qrbox: { width: 300, height: 100 },
    //       aspectRatio: 1,
    //     };

    //     // If you want to prefer back camera
    //     html5QrCode.start({ facingMode: "environment" }, config, qrCodeSuccessCallback);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  },
  methods: {
    submitData() {
      var data = {
        imeiList: this.imeiList.map((el) => el.imei), // array ของเลข imei ที่ add เข้ามาแลกคะแนน
        memberId: this.$store.state.member.id,
      };
      this.saveloading = true;
      axios
        .post(this.serverUrl + "yasale/earning-reward-points", data, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        })
        .then(async (response) => {
          this.saveloading = false;
          if (response.data.responsecode == 200) {
            this.query.view = "AddPointSuccess";
          } else {
            await this.$swal.fire({
              text: response.data.reason,
            });
            this.$liff.closeWindow();
          }
        });
    },
    deleteImei(k) {
      this.$swal
        .fire({
          text: "ยืนยันการลบ ?",
          showCancelButton: true,
        })
        .then((result) => {
          if (result.value) {
            this.imeiList.splice(k, 1);
          }
        });
    },
    async onAddImei() {
      if (await this.$refs.observer.validate()) {
        var response = await this.checkImei(this.input.imei);
        this.loading = false;
        if (response.responsecode == 200) {
          this.imeiList.push(response.data[0].info);
          this.input.imei = "";
          this.$refs.observer.reset();
        } else {
        }
      }
    },
    checkImei(imei) {
      return new Promise((resolve, reject) => {
        if (this.imeiList.some((el) => el.imei == imei)) {
          this.$swal.fire({
            text: "คุณได้กรอกเลข IMEI ซ้ำ",
          });
          resolve(false);
        }

        // this.imeiList.includes(imei);
        this.loading = true;
        axios
          .get(this.serverUrl + "yasale/duplicate-imei", {
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            params: { imei },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              if (response.data.data[0].info === null) {
                await this.$swal.fire({
                  text: "ไม่พบข้อมูลเลข IMEI นี้",
                });
                resolve(false);
              } else {
                resolve(response.data);
              }
            } else {
              await this.$swal.fire({ text: response.data.reason });
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
              resolve(response.data);
            }
          });
      });
    },
    async onDetectedCode(code) {
      this.input.imei = code;
      if (!this.loading) {
        var regeximei = /^\d{15}(,\d{15})*$/;
        // Limit 15 chars
        if (regeximei.test(code)) {
          this.loading = true;
          var response = await this.checkImei(code);

          if (response.responsecode == 200) {
            this.imeiList.push(response.data[0].info);
            this.input.imei = "";
            this.$refs.observer.reset();
            await this.$swal.fire({
              icon: "success",
              text: "เพิ่ม imei สำเร็จ",
            });
          } else {
            // await this.$swal.fire({
            //   text: "คุณได้กรอกเลข IMEI นี้ไปแล้ว",
            // });
          }
          this.loading = false;
        }
      }
    },

    // async onStreamBarcodeReader() {
    //   this.doStream = true;

    // },
    // onStopStreamReader(){

    //   this.$loadScript("https://unpkg.com/html5-qrcode")
    //   .then(() => {
    //     const html5QrCode = new Html5Qrcode("reader");
    //     html5QrCode.pause();
    //   });

    // },
    // async uploadToScan() {
    //   await this.$loadScript("https://unpkg.com/html5-qrcode")
    //   .then(() => {
    //     const html5QrCode = new Html5Qrcode("reader");
    //     // File based scanning
    //     const fileinput = document.getElementById('qr-input-file');
    //     fileinput.addEventListener('change', e => {
    //       if (e.target.files.length == 0) {
    //         // No file selected, ignore
    //         return;
    //       }

    //       const imageFile = e.target.files[0];
    //       // Scan QR Code
    //       html5QrCode.scanFile(imageFile, true)
    //       .then(decodedText => {
    //         // success, use decodedText
    //         console.log(decodedText);
    //       })
    //       .catch(err => {
    //         // failure, handle it.
    //         console.log(`Error scanning file. Reason: ${err}`)
    //       });
    //     });
    //   });
    // }
  },
};
</script>

<style lang="scss">
#barcode-scanner {
  position: relative;
}
#barcode-scanner canvas {
  position: absolute;
  left: 0px;
  top: 0px;
}
.redline {
  position: absolute;
  width: 100%;
  top: 0px;
  height: 10px;
  // background-color: green;
  border-top: 1px solid red;
  animation: redrunning 4s linear 2s infinite alternate;
}

@keyframes redrunning {
  0% {
    transform: translate(0, 0);
  }

  50% {
    transform: translate(0, 100px);
  }

  100% {
    transform: translate(0, 0);
  }
}
</style>
